import React from "react";
import { string } from "prop-types";
import styled, { useTheme } from "styled-components";

import DartyLogo from "@components/shared/Icons/Darty";
import FNACLogo from "@components/shared/Icons/FNAC";
import HomeTDLogo from "@components/shared/Icons/HomeTDLogo";
import CitroenLogo from "@components/shared/Icons/Citroen";
import FnacDartyIconContainer from "@components/shared/FnacDartyIconContainer";
import MediaMarktLogo from "@components/shared/Icons/MediaMarktLogo";

import { getStaticAssetURL } from "@lib/getStaticAssetURL";
import { testDriveType } from "@types";

import {
  TEST_DRIVE_TYPE_ID,
  TEST_DRIVE_TYPES,
  TEST_DRIVE_POINT_STORE_TYPE,
} from "@shared/constants";

const StyledLogo = styled(CitroenLogo)`
  height: 2.5rem;
  width: 2.5rem;
`;

const TestDrivePointLogo = ({ storeType, testDriveType }) => {
  const theme = useTheme();
  const testDriveTypeKey = TEST_DRIVE_TYPES.find(
    ({ id }) => id === testDriveType?.id
  )?.key;

  if (!testDriveType) {
    return null;
  }

  switch (storeType) {
    case TEST_DRIVE_POINT_STORE_TYPE.DARTY:
      return (
        <DartyLogo
          width="40px"
          height="40px"
          data-id={`point-logo-${testDriveTypeKey}`}
        />
      );
    case TEST_DRIVE_POINT_STORE_TYPE.FNAC:
      return (
        <FNACLogo
          width="40px"
          height="40px"
          data-id={`point-logo-${testDriveTypeKey}`}
        />
      );
    case TEST_DRIVE_POINT_STORE_TYPE.HOME:
      return (
        <HomeTDLogo
          width="40px"
          height="40px"
          data-id={`point-logo-${testDriveTypeKey}`}
        />
      );

    default:
      switch (testDriveType.id) {
        case TEST_DRIVE_TYPE_ID.FNAC_DARTY:
          return (
            <FnacDartyIconContainer dataId={`point-logo-${testDriveTypeKey}`} />
          );
        case TEST_DRIVE_TYPE_ID.SUPER:
          return (
            <img
              width={40}
              height={40}
              data-id={`point-logo-${testDriveTypeKey}`}
              src={getStaticAssetURL(
                `/images/testDrive/ami_super_fan_logo.png`
              )}
            />
          );
        case TEST_DRIVE_TYPE_ID.MEDIAMARKT:
          return <MediaMarktLogo data-id={`point-logo-${testDriveTypeKey}`} />;
        default:
          return (
            <StyledLogo
              color={
                testDriveType?.colorHexa
                  ? `#${testDriveType.colorHexa}`
                  : theme.colors.darkGrey
              }
              data-id={`point-logo-${testDriveTypeKey}`}
            />
          );
      }
  }
};

TestDrivePointLogo.propTypes = {
  storeType: string,
  testDriveType: testDriveType,
};

export default TestDrivePointLogo;
